import React, { Component } from "react";
import { Button, Image, Modal } from "semantic-ui-react";
import "./styles/sass/sign-in-guide-modal.scss";
import CheckCircleIcon from "../media/check-circle.png";
import CheckCircleLegacyIcon from "../media/check-circle (1).png";
import LinkIcon from "../media/link-icon.svg";
import ShieldIcon from "../media/shield-icon.svg";
import SignInIcon from "../media/sign-in-icon.svg";

const SSO_STEPS = [
  {
    title: "Open Unified platform",
    desc: "Go to the new platform URL.",
    showUrl: true,
  },
  {
    title: 'Click "Continue with SSO"',
    desc: "This is the primary button on the login screen. It will take you to a secure authentication page.",
  },
  {
    title: "Enter your email address",
    desc: "Use the same email you currently use for Customs360.",
  },
  {
    title: "Check your inbox and activate SSO access",
    desc: "You will receive an email with a link to activate your SSO access. Follow the instructions in that email to set up your credentials. This is a one-time step.",
  },
  {
    title: "Sign in with SSO going forward",
    desc: "Once activated, use Continue with SSO on every future login. No further steps required.",
  },
];

const LEGACY_STEPS = [
  {
    title: "Open Unified platform",
    desc: "Go to the new platform URL.",
    showUrl: true,
  },
  {
    title: 'Click "Use Legacy Sign In"',
    desc: (
      <>
        On the login screen, the primary button says <strong>Continue with SSO</strong>. Below it, click the{" "}
        <strong>Use Legacy Sign In</strong> link instead.
      </>
    ),
  },
  {
    title: "Enter your Customs360 credentials",
    desc: "Use the same email and password you use today. Nothing has changed.",
  },
];

class SignInGuideModal extends Component {
  state = { activeTab: "sso" };

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState({ activeTab: "sso" });
    }
  }

  openEngine = () => {
    window.location.href = this.props.engineLoginUrl;
  };

  renderUrlChip = () => (
    <div className="sig-url-chip">
      <img src={LinkIcon} alt="" className="sig-link-icon" />
      <span>{this.props.displayUrl}</span>
    </div>
  );

  renderSteps = (steps) => (
    <ol className="sig-steps">
      {steps.map((step, index) => (
        <li className="sig-step" key={step.title}>
          <span className="sig-step-num">{index + 1}</span>
          <div className="sig-step-body">
            <p className="sig-step-title">{step.title}</p>
            <p className="sig-step-desc">{step.desc}</p>
            {step.showUrl && this.renderUrlChip()}
          </div>
        </li>
      ))}
    </ol>
  );

  renderSsoTab = () => (
    <div className="sig-tab-panel">
      {this.renderSteps(SSO_STEPS)}
      <div className="sig-note sig-note-success">
        <Image src={CheckCircleIcon} alt="" className="sig-check-icon" />
        <p>
          SSO activation is a one-time process. If you are not ready right now, use Legacy Sign In first and activate
          SSO whenever you are ready.
        </p>
      </div>
    </div>
  );

  renderLegacyTab = () => (
    <div className="sig-tab-panel">
      <p className="sig-intro">
        Your existing Customs360 credentials (email address and password) work on unified platform right away. No setup
        needed.
      </p>
      {this.renderSteps(LEGACY_STEPS)}
      <div className="sig-note sig-note-neutral">
        <Image src={CheckCircleLegacyIcon} alt="" className="sig-check-icon" />
        <p>
          Legacy Sign In will remain available. You can switch to SSO at any time. See the{" "}
          <strong>Activate SSO Access</strong> tab for instructions.
        </p>
      </div>
    </div>
  );

  render() {
    const { open, onClose } = this.props;
    const { activeTab } = this.state;

    return (
      <Modal open={open} onClose={onClose} className="sig-modal" closeIcon>
        <Modal.Header className="sig-header">
          <p className="sig-title">How to sign in on Unified platform</p>
          <p className="sig-subtitle">Two options are available. Choose what works for you.</p>
        </Modal.Header>

        <Modal.Content className="sig-content">
          <div className="sig-tabs">
            <button
              type="button"
              className={`sig-tab ${activeTab === "sso" ? "active" : ""}`}
              onClick={() => this.setState({ activeTab: "sso" })}
            >
              <Image src={ShieldIcon} alt="" className="sig-tab-icon" /> Activate SSO Access
            </button>
            <button
              type="button"
              className={`sig-tab ${activeTab === "legacy" ? "active" : ""}`}
              onClick={() => this.setState({ activeTab: "legacy" })}
            >
              <Image src={SignInIcon} alt="" className="sig-tab-icon" /> Legacy Sign In
            </button>
          </div>

          <div className="sig-body-scroll">
            {activeTab === "sso" ? this.renderSsoTab() : this.renderLegacyTab()}
          </div>

          <div className="sig-actions">
            <Button className="sig-close-btn" onClick={onClose}>
              Close
            </Button>
            <Button primary className="sig-open-btn" onClick={this.openEngine}>
              Open Unified Platform
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default SignInGuideModal;
